import { render, staticRenderFns } from "./autocomplete-object.html?vue&type=template&id=cc48b5aa&scoped=true&"
import script from "./autocomplete-object.js?vue&type=script&lang=js&"
export * from "./autocomplete-object.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc48b5aa",
  null
  
)

export default component.exports